import { render } from "./Themeswitch.vue?vue&type=template&id=60a4939a&scoped=true"
import script from "./Themeswitch.vue?vue&type=script&lang=js"
export * from "./Themeswitch.vue?vue&type=script&lang=js"

import "./Themeswitch.vue?vue&type=style&index=0&id=60a4939a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a4939a"]])

export default __exports__